import { AlertTriangle, CheckCircle2, Info, OctagonAlert } from "lucide-react";

import type { CalloutBlock } from "@/types/blocks";

const TONE = {
  info: { stripe: "border-l-info", icon: Info, iconColor: "text-info" },
  success: { stripe: "border-l-success", icon: CheckCircle2, iconColor: "text-success" },
  warning: { stripe: "border-l-warning", icon: AlertTriangle, iconColor: "text-warning" },
  danger: { stripe: "border-l-destructive", icon: OctagonAlert, iconColor: "text-destructive" },
} as const;

/** A highlighted insight/warning. Neutral card fill; tone carried on the left
 *  stripe + icon (never a whole-surface tint — see the SPA CLAUDE.md rule). */
export function CalloutBlockView({ block }: { block: CalloutBlock }) {
  const tone = TONE[block.tone];
  const Icon = tone.icon;
  return (
    <div className={`flex gap-2.5 rounded-md border border-l-[3px] ${tone.stripe} bg-card p-3`}>
      <Icon size={16} className={`mt-0.5 shrink-0 ${tone.iconColor}`} />
      <div className="flex flex-col gap-0.5">
        <p className="text-sm font-medium text-foreground">{block.title}</p>
        {block.body && <p className="text-sm text-muted-foreground">{block.body}</p>}
      </div>
    </div>
  );
}
